// extracted by mini-css-extract-plugin
module.exports = {"activeDot":"__2point0_activeDot___1z6n","inactiveDot":"__2point0_inactiveDot__BiO9H"};